export class MemoryRingLogger {
    capacity;
    buffer = [];
    subscribers = new Set();
    constructor(capacity) {
        this.capacity = capacity;
        if (capacity <= 0)
            throw new Error('capacity must be > 0');
    }
    debug(category, message, data) {
        this.push('debug', category, message, data);
    }
    info(category, message, data) {
        this.push('info', category, message, data);
    }
    warn(category, message, data) {
        this.push('warn', category, message, data);
    }
    error(category, message, data) {
        this.push('error', category, message, data);
    }
    snapshot() {
        return [...this.buffer];
    }
    onEntry(cb) {
        this.subscribers.add(cb);
        return () => {
            this.subscribers.delete(cb);
        };
    }
    push(level, category, message, data) {
        const entry = Object.freeze({
            level,
            category,
            message,
            timestamp: Date.now(),
            ...(data !== undefined ? { data } : {}),
        });
        this.buffer.push(entry);
        while (this.buffer.length > this.capacity)
            this.buffer.shift();
        for (const s of this.subscribers)
            s(entry);
    }
}
export const createLogger = (sink, category) => ({
    debug: (m, d) => sink.debug(category, m, d),
    info: (m, d) => sink.info(category, m, d),
    warn: (m, d) => sink.warn(category, m, d),
    error: (m, d) => sink.error(category, m, d),
});
//# sourceMappingURL=logger.js.map